import { Check, Flame, Snowflake, Sparkles, CalendarHeart } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { NewsletterSignup } from "../components/NewsletterSignup";

const POINTS = [
  { icon: Sparkles, title: "Hypophyse & hypothalamus", loc: "Au centre de la pulpe du gros orteil", text: "Associés à la régulation du système endocrinien et hormonal." },
  { icon: Flame, title: "Les glandes surrénales", loc: "Au milieu de la voûte plantaire", text: "Liées à la gestion du stress et à la régulation thermique du corps." },
  { icon: Snowflake, title: "Yong Quan — 1R", loc: "Au centre de la plante du pied", text: "« Source Jaillissante » : pour s'ancrer et rafraîchir l'organisme." },
];

export default function GuideBouffees() {
  return (
    <div data-testid="guide-bouffees-page">
      <section className="pt-32 lg:pt-40 pb-10 px-6 lg:px-12 max-w-4xl mx-auto text-center">
        <Reveal>
          <span className="inline-flex items-center rounded-full bg-gold/90 px-5 py-2 text-xs uppercase tracking-[0.25em] text-olive-dark font-medium">
            Guide offert · Bien-être féminin
          </span>
          <h1 className="mt-7 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-ink leading-[1.08]">
            3 points de réflexologie pour apaiser les bouffées de chaleur
          </h1>
          <p className="mt-6 text-base sm:text-lg text-sage leading-relaxed max-w-2xl mx-auto">
            Les bouffées de chaleur accompagnent souvent les grands passages de la vie d'une femme. Recevez gratuitement mon guide : trois points doux à masser chez vous, en toute autonomie, pour retrouver un peu de fraîcheur et de calme.
          </p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-3 gap-5 text-left">
          {POINTS.map((p, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="h-full rounded-2xl border border-olive-border bg-beige-50 p-6" data-testid={`gb-point-${i}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-olive-soft border border-olive-border">
                  <p.icon className="w-5 h-5 text-olive" strokeWidth={1.5} />
                </span>
                <h3 className="mt-4 font-serif text-lg text-ink leading-snug">{p.title}</h3>
                <p className="mt-1 text-xs italic text-sage">{p.loc}</p>
                <p className="mt-2 text-sm text-sage leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <NewsletterSignup
        source="page-guide-bouffees"
        guide="bouffees"
        title="Recevez le guide « Apaiser les bouffées de chaleur »"
        description="3 points de réflexologie, la méthode d'auto-massage pas à pas et le bon moment pour les pratiquer. Offert, directement dans votre boîte mail — sans spam."
      />

      <section className="px-6 pb-24 max-w-2xl mx-auto text-center space-y-4">
        <p className="inline-flex items-center gap-2 text-sm text-olive" data-testid="gb-masterclass-teaser">
          <CalendarHeart className="w-4 h-4" strokeWidth={1.5} /> Une masterclass dédiée arrive en novembre — le guide vous préviendra de l'ouverture des inscriptions.
        </p>
        <p className="inline-flex items-center gap-2 text-sm text-sage">
          <Check className="w-4 h-4 text-olive" strokeWidth={2} /> Démarche de bien-être — ne remplace pas un avis médical.
        </p>
      </section>
    </div>
  );
}
